import React from "react";
import { valueToOption, options_input_type } from "../../atom/Apollo_styles";
import { RightDrawer } from "../../molecule/Apollo_RightDrawer";
import Button from "@material-ui/core/Button";
import moment from "moment";

// @ts-ignore
export const InformationDrawer = ({ obj, closeInformation, typeTitle, createdBy, updatedBy }) => {
    let inputType: string = "";
    if (typeTitle !== "") {
        inputType = valueToOption(obj.inputType, options_input_type).label;
    }

    let uu: string = "0";
    if (obj.uu !== undefined) {
        uu = obj.uu.toLocaleString();
    }

    let nullDate: string = "0001-01-01";
    let lastUpdateAt: string = "";
    let createdAt: string = "";
    let uploadedAt: string = "";

    if (obj.updatedAt.indexOf(nullDate) === -1) {
        lastUpdateAt = moment(obj.updatedAt).format("YYYY/MM/DD HH:mm:ss");
    }
    if (obj.createdAt.indexOf(nullDate) === -1) {
        createdAt = moment(obj.createdAt).format("YYYY/MM/DD HH:mm:ss");
    }
    if (obj.uploadedAt.indexOf(nullDate) === -1) {
        uploadedAt = moment(obj.uploadedAt).format("YYYY/MM/DD HH:mm:ss");
    }

    React.useEffect(() => {

    }, []);

    return (
        <RightDrawer>
            <h1 
                style={{
                textAlign: "center", 
                fontSize: "20px",
                color: "#1976d2"
                }}
            >
                情報
            </h1>
            <hr 
                style={{color: "blue", width: "100%"}}
            />
            <table style={{fontSize: "18px", lineHeight: "200%"}}>
                {typeTitle !== "" ? 
                    <tr>
                        <td>{typeTitle}：</td>
                        <td>{inputType}</td>
                    </tr>
                : ""}
                <tr>
                    <td>UU：</td>
                    <td>{uu}</td>
                </tr>
                <tr>
                    <td>最終更新：</td>
                    <td>{lastUpdateAt}</td>
                </tr>
                <tr>
                    <td>最終更新ユーザー：</td>
                    <td>{updatedBy}</td>
                </tr>
                <tr>
                    <td>作成日時：</td>
                    <td>{createdAt}</td>
                </tr>
                <tr>
                    <td>作成者：</td>
                    <td>{createdBy}</td>
                </tr>
                <tr>
                    <td>最終ファイル作成：</td>
                    <td>{uploadedAt}</td>
                </tr>
            </table>
            <br />
            <Button 
                variant="contained" 
                color="secondary"
                style={{padding: "10px", fontSize: "17px"}}
                onClick={() => closeInformation()}
            >
                閉じる
            </Button>
        </RightDrawer>
    );
};
